import { ButtonDownloadComponent, ButtonsActionsTableComponent, CheckTableComponent, RichTextAreaComponent } from '@app/shared';
import { EventEmitter } from '@angular/core';
import { DateFormatPipe } from '@app/shared/pipes/moment/date-format.pipe';

export class UtilidadesConfig {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};
  // Contiene la configuracion de la modal
  settingsModal = {};
  accionModal: any;

  constructor() {
    const self = this;
    this.settings = {
      selectMode: 'external',
      noDataMessage: 'No hay resultados',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        codigo: {
            editable: false,
            addable: false,
            title: 'CÓDIGO',
            filter: {
              inputClass: 'form-control',
            },
          },
          documento: {
            editable: false,
            addable: false,
            type: 'custom',
            renderComponent: RichTextAreaComponent,
            title: 'SERIES,SUBSERIES, UNIDADES Y TIPOS DOCUMENTALES',
            filter: {
              inputClass: 'form-control',
            },
          },
          soporte: {
            editable: false,
            addable: false,
            title: 'Soporte',
            filter: {
              inputClass: 'form-control',
            },
          },
          ag: {
            editable: false,
            addable: false,
            title: 'AG',
            filter: {
              inputClass: 'form-control',
            }
          },
          ac: {
            editable: false,
            addable: false,
            title: 'AC',
            filter: {
              inputClass: 'form-control',
            }
          },
          ct: {
            editable: false,
            addable: false,
            title: 'CT',
            type: 'custom',
            renderComponent: CheckTableComponent,
            filter: {
                  inputClass: 'form-control',
                  type: 'checkbox',
                  config: {
                    true: 'true',
                    false: 'false',
                    resetText: 'Todo',
                  },
                }
          },
          e: {
            editable: false,
            addable: false,
            title: 'E',
            type: 'custom',
            renderComponent: CheckTableComponent,
            filter: {
                  inputClass: 'form-control',
                  type: 'checkbox',
                  config: {
                    true: 'true',
                    false: 'false',
                    resetText: 'Todo',
                  },
                }
          },
          md: {
            editable: false,
            addable: false,
            title: 'MD',
            type: 'custom',
            renderComponent: CheckTableComponent,
            filter: {
                  inputClass: 'form-control',
                  type: 'checkbox',
                  config: {
                    true: 'true',
                    false: 'false',
                    resetText: 'Todo',
                  },
                }
          },
          s: {
            editable: false,
            addable: false,
            title: 'S',
            type: 'custom',
            renderComponent: CheckTableComponent,
            filter: {
                  inputClass: 'form-control',
                  type: 'checkbox',
                  config: {
                    true: 'true',
                    false: 'false',
                    resetText: 'Todo',
                  },
                }
          },
          procedimiento: {
            editable: false,
            addable: false,
            title: 'PROCEDIMIENTO',
            filter: {
              inputClass: 'form-control',
            }
          },
      },
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/utilidades/shared/utilitdades.config.service.ts